import {writable} from 'svelte/store';
import {I_PERSON} from "../../../../../lib/datatypes";
import {sortCompareASC} from "../../../../../lib/utils";

export const people = writable({
    list: [],
    lookup: {}
});
export const people_fetching = writable(false);

const _createLookup = people => {
    let result = {};
    for(let i = 0, n = people.length; i < n; i++) {
        result[people[i][I_PERSON.ID]] = people[i];
    }
    return result;
};

const _updateStructures = people => {
    people.list.sort((a, b) => sortCompareASC(a[I_PERSON.LAST_NAME].toLowerCase(), b[I_PERSON.LAST_NAME].toLowerCase()));
    people.lookup = _createLookup(people.list);
};

let $people = null;
const unsubscribe = people.subscribe(val => $people = val);

// Explicitly set the contents of people by passing them in, ie from bootstrapped data
export const setPeople = people_data => {
    people.update(people => {
        people.list = people_data;
        _updateStructures(people);
        return people;
    });
};

export const loadPeople = async () => {
    people_fetching.set(true);

    const response = await fetch(`/api/people`);
    let result = await response.json();
    people_fetching.set(false);
    people.update(people => {
        people.list = result;
        _updateStructures(people);
        return people;
    });
};

export const addRawPerson = async (person_arr) => {
    people_fetching.set(true);

    const url = `/api/person/add`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(person_arr)
    });
    let result = await response.json();
    people_fetching.set(false);
    people.update(people => {
        people.list.push(result);
        _updateStructures(people);
        return people;
    });
    return result;
};

export const updateRawPerson = async person => {
    people_fetching.set(true);

    const url = `/api/person/${person[I_PERSON.ID]}/update`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(person)
    });
    let result = await response.json();
    // console.log(response, result);
    // ..update local copy of people with the updated data - could just download the data again (server would have updated data), but..
    const i = $people.list.findIndex(el => el[I_PERSON.ID] === person[I_PERSON.ID]);
    people_fetching.set(false);
    people.update(people => {
        people.list[i] = result;  // @ASSUMPTION that the result will always contain a 'person', ie doesn't handle errors
        _updateStructures(people);
        return people;
    });
    return result;
};